import React from 'react';
import UserHeader from './UsersHeader';

import { Box } from '@mui/material';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';

const Index = () => {
  const fetchUsers = async () => {
    const res = await axios.get(API_URL + '/test/users-submissions', {
      params: { limit: 0 },
    });
    return res;
  };
  const { status, data } = useQuery(`fetchUsers`, fetchUsers);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && <UserHeader data={data.data.data || []} />}
    </div>
  );
};

export default Index;
